export const wrongAnswer = new Audio(
  'http://commondatastorage.googleapis.com/codeskulptor-assets/Collision8-Bit.ogg'
);
export const correctAnswer = new Audio(
  'http://codeskulptor-demos.commondatastorage.googleapis.com/descent/gotitem.mp3'
);
export const perdidoDescartes = new Audio(
  'https://firebasestorage.googleapis.com/v0/b/sagas-24491.appspot.com/o/perdido_descartes.mp3?alt=media&token=d8e32a33-13ec-454a-b85f-4f79f78c33ed'
);
export const perdidoEinstein = new Audio(
  'https://firebasestorage.googleapis.com/v0/b/sagas-24491.appspot.com/o/perdido_einstein.mp3?alt=media&token=e49e3513-bcd8-4428-93e6-60258bb50b86'
);
export const perdidoTharp = new Audio(
  'https://firebasestorage.googleapis.com/v0/b/sagas-24491.appspot.com/o/perdido_tharp.mp3?alt=media&token=896c7299-2af3-4deb-be57-739870cd2964'
);
export const nein = new Audio(
  'https://firebasestorage.googleapis.com/v0/b/sagas-24491.appspot.com/o/nein.mp3?alt=media&token=eb893ada-8128-460a-ac63-1e251f5ba709'
);